import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';

interface AlarmSoundContextType {
  isMuted: boolean;
  toggleMute: () => void;
  setMuted: (muted: boolean) => void;
}

const AlarmSoundContext = createContext<AlarmSoundContextType | undefined>(undefined);

export const AlarmSoundProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isMuted, setIsMuted] = useState(false);

  const toggleMute = () => {
    setIsMuted(prev => !prev);
  };

  const setMuted = (muted: boolean) => {
    setIsMuted(!!muted);
  };

  const contextValue = useMemo(() => ({ isMuted, toggleMute, setMuted }), [isMuted]);

  return (
    <AlarmSoundContext.Provider value={contextValue}>
      {children}
    </AlarmSoundContext.Provider>
  );
};

export const useAlarmSoundContext = () => {
  const context = useContext(AlarmSoundContext);
  if (!context) {
    throw new Error('useAlarmSoundContext must be used within AlarmSoundProvider');
  }
  return context;
};
